import React, {FC} from 'react'
import * as styles from './ratingStyle.module.css'
import Stars from './Stars'

interface RatingPropTypes {
    rating: number
    reviewCount?: number
    siteId: string
}

const RatingsSfra: FC<RatingPropTypes> = ({rating, reviewCount, siteId}) => {
    const filledStars = Math.floor(rating)
    const remainder = rating - filledStars
    const starProps = {
        filledStars,
        remainder,
        siteId
    }

    return (
        <div
            style={{display: 'flex'}}
            className={styles.ratingsAlignment}
            data-testid="RatingsSfra-Flex"
        >
            <div className={styles.starsContainer}>
                <Stars {...starProps} data-testid="RatingsSfra-Stars" />
            </div>
            <label className={styles.label}>{reviewCount ? reviewCount : '0'} Reviews</label>
        </div>
    )
}

export default RatingsSfra
